"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M25.414 16.3l10.645 10.65a2 2 0 0 1 0 2.828l-.282.282a2.006 2.006 0 0 1-2.828 0L24 21.112l-8.95 8.948a2.006 2.006 0 0 1-2.828 0l-.282-.282a2 2 0 0 1 0-2.828L22.585 16.3a2 2 0 0 1 2.829 0z" })
);

